import { useState } from 'react';
import { Copy } from 'lucide-react';
import { PROFILE_STORES_GENERATE_CODE } from '../../../../shared/constants/endpoints';
import useApiRequest from '../../../../shared/hooks/useApiRequest';
import './StoreCodeGenerator.css';

const StoreCodeGenerator = ({
  request,
  authToken,
  storeName,
  storeCode,
  onStoreCodeChange,
  onToast,
  runWithGlobalLoader
}) => {
  const [isGeneratingCode, setIsGeneratingCode] = useState(false);
  const { execute: executeGenerateCode } = useApiRequest();

  const handleGenerateStoreCode = async () => {
    if (!storeName || !storeName.trim()) {
      onToast?.({ message: 'Please enter a store name first', variant: 'error' });
      return;
    }

    try {
      setIsGeneratingCode(true);
      const response = await executeGenerateCode(
        () => runWithGlobalLoader(() => request(PROFILE_STORES_GENERATE_CODE, {
          method: 'POST',
          body: JSON.stringify({ storeName: storeName.trim() }),
          requestName: 'generate-store-code'
        })),
        { logModule: 'store-code-generator' }
      );

      if (response?.data) {
        onStoreCodeChange(response.data);
        onToast?.({ message: 'Store code generated successfully', variant: 'success' });
      }
    } catch (error) {
      onToast?.({ message: 'Failed to generate store code', variant: 'error' });
    } finally {
      setIsGeneratingCode(false);
    }
  };

  return (
    <div className="input-group store-code-wrapper-group store-code-generator-shell">
      <label className="input-label">Store Code</label>
      <div className="store-code-wrapper">
        <input
          className="input"
          value={storeCode}
          disabled
        />
        {storeCode && (
          <button
            type="button"
            className="copy-btn"
            title="Copy store code"
            onClick={() => {
              navigator.clipboard.writeText(storeCode);
              onToast?.({ message: 'Store code copied to clipboard!', variant: 'success' });
            }}
          >
            <Copy size={16} />
          </button>
        )}
        <button
          type="button"
          className="btn primary small"
          onClick={handleGenerateStoreCode}
          disabled={isGeneratingCode || !storeName}
          title={!storeName ? 'Add a store name to enable' : (isGeneratingCode ? 'Generating...' : '')}
        >
          {isGeneratingCode ? 'Generating...' : (storeCode ? 'Regenerate' : 'Generate')}
        </button>
      </div>
    </div>
  );
};

export default StoreCodeGenerator;
